// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "simsandbox/v1/simsandbox.proto" (package "simsandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for running a simulation sandbox against a machine part.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message simsandbox.v1.CreateSimSandboxRequest
 */
export interface CreateSimSandboxRequest {
    /**
     * The part the sandbox runs against; the caller must have control access.
     *
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.CreateSimSandboxResponse
 */
export interface CreateSimSandboxResponse {
    /**
     * The sandbox's opaque identifier, for DestroySimSandbox and GetSimSandboxStatus.
     *
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.DestroySimSandboxRequest
 */
export interface DestroySimSandboxRequest {
    /**
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.DestroySimSandboxResponse
 */
export interface DestroySimSandboxResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxStatusRequest
 */
export interface GetSimSandboxStatusRequest {
    /**
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxStatusResponse
 */
export interface GetSimSandboxStatusResponse {
    /**
     * @generated from protobuf field: simsandbox.v1.SandboxState state = 1;
     */
    state: SandboxState;
}
/**
 * @generated from protobuf message simsandbox.v1.GetMachineSimSandboxesRequest
 */
export interface GetMachineSimSandboxesRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.GetMachineSimSandboxesResponse
 */
export interface GetMachineSimSandboxesResponse {
    /**
     * At most one per part; parts that have never had a sandbox are omitted.
     *
     * @generated from protobuf field: repeated simsandbox.v1.SimSandbox sandboxes = 1;
     */
    sandboxes: SimSandbox[];
}
/**
 * SimSandbox is a part's most recently started sandbox.
 *
 * @generated from protobuf message simsandbox.v1.SimSandbox
 */
export interface SimSandbox {
    /**
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
    /**
     * @generated from protobuf field: string part_id = 2;
     */
    partId: string;
    /**
     * As recorded rather than asked of the provider, so a sandbox that exits on
     * its own reads STARTED until the exit is detected.
     *
     * @generated from protobuf field: simsandbox.v1.SandboxState state = 3;
     */
    state: SandboxState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 4;
     */
    startedAt?: Timestamp;
}
/**
 * SandboxState is the recorded lifecycle state of a sandbox.
 *
 * @generated from protobuf enum simsandbox.v1.SandboxState
 */
export enum SandboxState {
    /**
     * @generated from protobuf enum value: SANDBOX_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Recorded before the provider is asked to start the sandbox.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * The provider started the sandbox.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_STARTED = 2;
     */
    STARTED = 2,
    /**
     * The sandbox never started, or was torn back down.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_FAILED = 3;
     */
    FAILED = 3,
    /**
     * A started sandbox was destroyed.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_TERMINATED = 4;
     */
    TERMINATED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateSimSandboxRequest$Type extends MessageType<CreateSimSandboxRequest> {
    constructor() {
        super("simsandbox.v1.CreateSimSandboxRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.CreateSimSandboxRequest
 */
export const CreateSimSandboxRequest = new CreateSimSandboxRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSimSandboxResponse$Type extends MessageType<CreateSimSandboxResponse> {
    constructor() {
        super("simsandbox.v1.CreateSimSandboxResponse", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.CreateSimSandboxResponse
 */
export const CreateSimSandboxResponse = new CreateSimSandboxResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DestroySimSandboxRequest$Type extends MessageType<DestroySimSandboxRequest> {
    constructor() {
        super("simsandbox.v1.DestroySimSandboxRequest", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.DestroySimSandboxRequest
 */
export const DestroySimSandboxRequest = new DestroySimSandboxRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DestroySimSandboxResponse$Type extends MessageType<DestroySimSandboxResponse> {
    constructor() {
        super("simsandbox.v1.DestroySimSandboxResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.DestroySimSandboxResponse
 */
export const DestroySimSandboxResponse = new DestroySimSandboxResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxStatusRequest$Type extends MessageType<GetSimSandboxStatusRequest> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxStatusRequest", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxStatusRequest
 */
export const GetSimSandboxStatusRequest = new GetSimSandboxStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxStatusResponse$Type extends MessageType<GetSimSandboxStatusResponse> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxStatusResponse", [
            { no: 1, name: "state", kind: "enum", T: () => ["simsandbox.v1.SandboxState", SandboxState, "SANDBOX_STATE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxStatusResponse
 */
export const GetSimSandboxStatusResponse = new GetSimSandboxStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachineSimSandboxesRequest$Type extends MessageType<GetMachineSimSandboxesRequest> {
    constructor() {
        super("simsandbox.v1.GetMachineSimSandboxesRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetMachineSimSandboxesRequest
 */
export const GetMachineSimSandboxesRequest = new GetMachineSimSandboxesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachineSimSandboxesResponse$Type extends MessageType<GetMachineSimSandboxesResponse> {
    constructor() {
        super("simsandbox.v1.GetMachineSimSandboxesResponse", [
            { no: 1, name: "sandboxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandbox }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetMachineSimSandboxesResponse
 */
export const GetMachineSimSandboxesResponse = new GetMachineSimSandboxesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandbox$Type extends MessageType<SimSandbox> {
    constructor() {
        super("simsandbox.v1.SimSandbox", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["simsandbox.v1.SandboxState", SandboxState, "SANDBOX_STATE_"] },
            { no: 4, name: "started_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandbox
 */
export const SimSandbox = new SimSandbox$Type();
/**
 * @generated ServiceType for protobuf service simsandbox.v1.SimSandboxService
 */
export const SimSandboxService = new ServiceType("simsandbox.v1.SimSandboxService", [
    { name: "CreateSimSandbox", options: {}, I: CreateSimSandboxRequest, O: CreateSimSandboxResponse },
    { name: "DestroySimSandbox", options: {}, I: DestroySimSandboxRequest, O: DestroySimSandboxResponse },
    { name: "GetSimSandboxStatus", options: {}, I: GetSimSandboxStatusRequest, O: GetSimSandboxStatusResponse },
    { name: "GetMachineSimSandboxes", options: {}, I: GetMachineSimSandboxesRequest, O: GetMachineSimSandboxesResponse }
]);
